import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { GzTabWebComponent } from '../../../../ui/gzTabs/gzTab';
import { EasmScanConfigurationItemFormWebComponent } from '../../easmScanConfigurationItemForm';
import { EasmScanConfigurationAssetGridWebComponent } from '../../easmScanConfigurationAssetGrid';
import { GzTabGroupWebComponent } from '../../../../ui/gzTabs/gzTabGroup';
import { EasmScanConfigurationSchedulerWebComponent } from '../../easmScanConfigurationScheduler';
import { GzTitleWebComponent } from '../../../../ui/gzTitle';
import { GzTextWebComponent } from '../../../../ui/gzText';

export class EasmScanConfigurationView extends BaseWebComponentView {
  public companyId: string;
  public dom: {
    $wrapper: HTMLElement;

    $scanTabGroup: GzTabGroupWebComponent;
    $addAssetToScanTab: GzTabWebComponent;
    $excludeAssetFromScanTab: GzTabWebComponent;

    $noResultsContainer: HTMLElement;
    $noResultsMessage: GzTitleWebComponent;
    $noResultsAdditionalText: GzTextWebComponent;

    $assetForm: EasmScanConfigurationItemFormWebComponent;
    $assetGrid: EasmScanConfigurationAssetGridWebComponent;
    $scheduler: EasmScanConfigurationSchedulerWebComponent;

    $legalInfoText: GzTextWebComponent;
  };

  public getDomElements(): void {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');

    this.dom.$scanTabGroup = this.shadow.querySelector('#scan-tab-group');
    this.dom.$addAssetToScanTab = this.shadow.querySelector('#add-asset-to-scan-tab');
    this.dom.$excludeAssetFromScanTab = this.shadow.querySelector('#exclude-asset-from-scan-tab');

    this.dom.$addAssetToScanTab.label = this.dependencies.translateFn('Scan list');
    this.dom.$excludeAssetFromScanTab.label = this.dependencies.translateFn('Scan exclusions');

    this.dom.$noResultsContainer = this.shadow.querySelector('#no-results');
    this.dom.$noResultsMessage = this.shadow.querySelector('#no-results-message');
    this.dom.$noResultsAdditionalText = this.shadow.querySelector('#no-results-additional-text');

    this.dom.$noResultsMessage.innerText = this.dependencies.translateFn('Empty list');
    this.dom.$noResultsAdditionalText.innerText = this.dependencies.translateFn(
      'No assets have been added to the list.'
    );

    this.dom.$assetForm = this.shadow.querySelector('gz-easm-scan-configuration-item-form');
    this.dom.$assetGrid = this.shadow.querySelector('gz-easm-scan-configuration-asset-grid');
    this.dom.$scheduler = this.shadow.querySelector('gz-easm-scan-configuration-scheduler');

    this.dom.$legalInfoText = this.shadow.querySelector('#legal-info-text');
    this.dom.$legalInfoText.innerText = this.dependencies.translateFn(
      'By scanning these assets, you acknowledge that Bitdefender may utilize public internet services (referred in the EASM chapter from the Data Collection Policy) to gather additional publicly available information related to these assets. For additional details on the personal data processed for your company through the Bitdefender EASM service, please refer to the Data Collection Policy for GravityZone Cloud. This information is available upon request from your Account Manager or Enterprise Support.'
    );
  }

  public buildView(data: any): void {
    if (this.dom.$assetGrid.injectDependencies) {
      this.dom.$assetGrid.injectDependencies(this.dependencies);
      this.dom.$assetGrid.controller?.view.setCompanyId(this.companyId);
      this.dom.$assetGrid.start().catch(console.error);
    }

    if (this.dom.$scheduler.injectDependencies) {
      this.dom.$scheduler.injectDependencies(this.dependencies);
      this.dom.$scheduler.controller?.setCompanyId(this.companyId);
      this.dom.$scheduler.start().catch(console.error);
    }
  }

  public showNoResultsPanel(): void {
    this.setElementClass(this.dom.$assetGrid, 'hidden');
    this.removeElementClass(this.dom.$noResultsContainer, 'hidden');
  }

  public showGrid(): void {
    this.removeElementClass(this.dom.$assetGrid, 'hidden');
    this.setElementClass(this.dom.$noResultsContainer, 'hidden');
  }
}
